<template>
  <div
    class="modal"
    @click="$emit('close-modal')"
  >
    <div class="container pa-5">
      <img
        :src="foto"
        :alt="foto"
        class="img-fluid"
      >
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'modal',
  props: ['foto']
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  min-width: 720px;
  min-height: 720px;
  z-index: 10;
  top: 0;
  left: 0;
  display: block;
  background: rgba(0, 0, 0, 0.5);
  padding-top: 100px;
  img {
    margin: auto;
    object-fit: cover;
    height: 630px;
    width: 1072px;
  }
}
</style>
